import React, { useState } from 'react';
import Notes from 'components/Notes';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import { CREATE_STAFF_NOTE, DELETE_STAFF_NOTE_BY_STAFF_NOTE_ID } from 'graphql/service';
import { useMutation } from '@apollo/client';
import Cookies from 'js-cookie';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { retry } from "utils/util";

const GeneralStaffNotes = ({
  notes,
  setNotes,
  staffId
}) => {

  const userId = Cookies.get('userId') || ''
  const fullName = Cookies.get("fullName") || ""
  const [note, setNote] = useState('')
  const [isSaving, setIsSaving] = useState(false);
  const pageSize = 3

  const [addNote] = useMutation(CREATE_STAFF_NOTE)

  const [removeNote] = useMutation(DELETE_STAFF_NOTE_BY_STAFF_NOTE_ID)

  const onAddNote = async () => {
    if (isSaving) return;
    if (note.trim() === '') {
      debouncedErrorMessage("Note can't be empty");
      return;
    }
    const tempId = Math.random().toString(36).substring(2, 15);
    setNotes(prevNotes => {
      const newNotes = [...prevNotes];
      newNotes.push({
        noteId: tempId,
        notes: note,
        createdBy: {
          fullName: fullName,
        },
        createdAt: Date.now(),
        unsynced: true,
      });
      return newNotes
    });
    setNote("");
    setIsSaving(true);
    try {
      // Retry addition a few times
      const res = await retry(() => (
        addNote({
          variables: {
            input: {
              staffId,
              createdBy: userId,
              notes: note,
            },
          },
        })
      ));
      //update note id with the id from backend
      const realId = res.data?.createStaffNote.id
      if (!realId) return;
      setNotes((prevNotes) => {
        return prevNotes.map((n) => {
          if (n.noteId === tempId) {
            return { ...n, noteId: realId, unsynced: false };
          }
          return n;
        });
      });
    } catch(error) {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
      setNotes(prevNotes => {
        const index = prevNotes.findIndex(n => n.noteId === tempId);
        if (index === -1) return prevNotes;

        const next = [...prevNotes];
        next.splice(index, 1);
        return next;
      });
    }
    setIsSaving(false);
  };

  const onRemoveNote = async (noteId) => {
    // Remove immediately (optimistic UI)
    let removedNote;
    setNotes(prev => {
      const temp = prev.filter(n => n.noteId !== noteId);
      removedNote = prev.find(n => n.noteId === noteId);
      return temp;
    });

    try {
      // Retry deletion a few times
      await retry(() =>
        removeNote({
          variables: { noteId },
        })
      );
    } catch (error) {
      // Restore the note if deletion failed after all retries
      setNotes(prev => [removedNote, ...prev]);

      let content = error.message;
      if (!error.networkError && error.message.includes("Validation")) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className='type'>GENERAL STAFF NOTES</div>
      </CardHeader>
      <Notes
        notes={notes}
        note={note}
        setNote={setNote}
        onAddNote={onAddNote}
        // loading={loading}
        onRemoveNote={onRemoveNote}
        pageSize={pageSize}
      />
    </Card>
  );
};

export default GeneralStaffNotes;
